import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  DualIcon,
  FormFieldSet,
  LogoLoader,
  showToast,
  SmartTooltip,
  TableAdv,
} from "../../../../components";
import { dateFormator, mapTableRows, exactUTCDate } from "../../../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllNotes,
  updateSubmissionStatus,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { fetchConfirmedOrStartStart } from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import { usePagination } from "../../../../hooks";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import AddNoteModal from "./modals/AddNoteModal";
import ApplicantsDetailsDrawer from "../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";

import { Link, useNavigate } from "react-router-dom";
const ApplicantSubStatus = {
  1: "shortlisted",
  2: "pipeline",
  3: "Submitted",
  4: "Review call by BDM",
  5: "BDM Interview",
  6: "Disqualified",
  7: "Hold",
  8: "Withdrawn",
  9: "Waiting for Writeup",
  10: "Submitted to Client",
  11: "Submitted To Vendor",
  12: "Shortlisted for Interview",
  13: "Interview Confirmation",
  14: "Interview Scheduled",
  15: "L1 Interview Scheduled",
  16: "L2 Interview Scheduled",
  17: "L3 Interview Scheduled",
  18: "L1 Interview Selected",
  19: "L2 Interview Selected",
  20: "L3 Interview Selected",
  21: "L1 Interview Rejected",
  22: "L2 Interview Rejected",
  23: "L3 Interview Rejected",
  24: "L1 Interview Re-Scheduled",
  25: "L2 Interview Re-Scheduled",
  26: "L3 Interview Re-Scheduled",
  27: "L1 Interview Feedback Pending",
  28: "L2 Interview Feedback Pending",
  29: "L3 Interview Feedback Pending",
  30: "Rejected By Client",
  31: "Selected but no response from the client",
  32: "Rejected after Client Selection",
  33: "Submitted to End Client",
  34: "Vendor Interview",
  35: "Vendor Interview Reject",
  36: "Client Interview",
  37: "Client Interview Select",
  38: "Client Interview Reject",
  39: "Client Interview Completed",
  40: "End Client Interview",
  41: "End Client Interview Completed",
  42: "Selected By Vendor",
  43: "Selected By Client",
  44: "Selected By End Client",
  45: "Rejected By Vendor",
  46: "Rejected by End Client",
  47: "Disqualified By Vendor",
  48: "Disqualified By Client",
  49: "Disqualified by End Client",
  50: "Hold By Vendor",
  51: "Hold By Client",
  52: "Hold by End Client",
  53: "Drop",
  54: "Position on Hold",
  55: "PW Interview Proposed By Buyer",
  56: "PW Interview Proposed By Supplier",
  57: "PW Interview Failed",
  58: "PW Interview Cancelled",
  59: "PW Interview Success",
  60: "Assignment Contract Sent",
  61: "Assignment Contract Verified",
  62: "Assignment Contract Rejected",
  63: "Confirmed",
  64: "Position Filled",
  65: "Backout",
  66: "Not Joined",
  67: "BGV Failed",
  68: "Got Pay Rate Confirmation",
  69: "Offer Withdrawn",
  70: "Negotiation",
  71: "Start",
  72: "Offer Sent",
  73: "Offer Accepted",
  74: "Offer Rejected",
  75: "Hold with Client",
  76: "Hold with Vendor",
};
const Confirmed = () => {
  const [noteModal, setNotesModal] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { value } = useSelector((state) => state.totalCount);
  const { confirmedOrStart } = useSelector((state) => state.bdmJobs);
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const { data, loading } = confirmedOrStart;
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [hoveredNotes, setHoveredNotes] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);

  const totalCount = value?.confirmedSubCount?.data || 0;
  const applicantStatusOptions = Object.entries(ApplicantSubStatus).map(
    ([key, value]) => ({
      label: value,
      value: Number(key),
    }),
  );

  const filterData = confirmedOrStart?.data.find(
    (data) => data?.candidateId?.uiid === selectedApplicantId,
  );

  const getHoveredNotes = async (notes) => {
    setHoveredNotes([]);

    try {
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
    }
  };

  const columns = [
    {
      key: "icons",
      label: "",
      width: "min-w-[150px]! max-w-[250px]!",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            color="black"
            icon={"visibility"}
            size="sm"
            variant="text"
            // size="sm"
            // icon="article"
            // badgeIcon="visibility"
            // iconColor="info"
            // dotPosition="bottom-right"
            onClick={() => {
              setSelectedApplicantId(row?.candidateUiid);
              setDetailsDrawer(true);
            }}
          />
          {row?.notes?.length > 0 && (
            <div
              onMouseEnter={() =>
                row?.notes?.length > 0 ? getHoveredNotes(row?.notes) : {}
              }
              onMouseLeave={() => setHoveredNotes([])}
            >
              <DualIcon
                size="sm"
                icon="chat"
                badgeIconColor={
                  row?.notes?.length > 0 ? "bg-success" : "bg-dark"
                }
                onClick={() => {
                  setSelectedApplicantId(row?.candidateUiid);
                  setNotesModal(true);
                }}
                tooltipDescription={
                  Array.isArray(hoveredNotes) && hoveredNotes?.length > 0 ? (
                    <div className="flex flex-col gap-2">
                      {hoveredNotes.map((hoveredNote, i) => (
                        <p key={i}>
                          "{hoveredNote?.note || ""}" by{" "}
                          {formatWords2(hoveredNote?.addedBy?.firstName) || ""}{" "}
                          on{" "}
                          {dateFormator(
                            convertFromUTC(hoveredNote?.addedOn),
                            "datetime-ampm",
                          ) || ""}
                        </p>
                      ))}
                    </div>
                  ) : (
                    "Add note"
                  )
                }
                tooltipDelay={500}
                showTooltip={true}
              />
            </div>
          )}
        </div>
      ),
    },
    {
      key: "fullName",
      label: "Candidate Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.fullName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.fullName}</div>
        </SmartTooltip>
      ),
    },
    // {
    //   key: "startDate",
    //   label: "Start Date",
    // },
    // {
    //   key: "interviewEndDate",
    //   label: "Interview End Date",
    // },
    {
      key: "accountName",
      label: "Account Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row.accountName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.accountName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobtitle",
      label: "Job Title",
      width: "min-w-[230px]! max-w-[270px]!",
      render: (row) => (
        <SmartTooltip
          description={row.jobtitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.jobtitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobid",
      label: "Job ID",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        <SmartTooltip
          description={row.jobid}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row.jobid}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "createdby",
      label: "Job Created By",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "createdon",
      label: "Job Created On",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    //   {
    //   key: "candidateStatus",
    //   label: "Candidate Status",
    //   width: 220,
    //   render: (row) => (
    //     <div className="w-[180px] min-w-[160px]">
    //       <FormFieldSet
    //         type="select"
    //         noTitle
    //         size="sm"
    //         value={
    //           row?.statusHistory?.[row?.statusHistory?.length - 1]?.status || ""
    //         }
    //         // options={Object.entries(ApplicantSubStatus).map(([key, value]) => ({
    //         //   label: value,
    //         //   value: Number(key),
    //         // }))}
    //          options={[
    //           { label: "Confirmed", value: 63 },
    //           { label: "Backout", value: 65 },
    //           { label: "Not Joined", value: 66 },
    //           { label: "BGV Failed", value: 67 },
    //           { label: "Start", value: 71 },
    //         ]}
    //         onChange={(option) => handleStatusChange(option, row)}
    //       />
    //     </div>
    //   ),
    // }
    {
      key: "candidateStatus",
      label: "Candidate Status",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => {
        const lastStatus =
          row?.statusHistory?.[row?.statusHistory?.length - 1]?.status;

        const currentStatus =
          applicantStatusOptions.find((opt) => opt.value === lastStatus) ||
          null;

        return (
          <div className="flex items-center w-full">
            <div className="w-full">
              <FormFieldSet
                type="select"
                noTitle
                size="sm"
                value={currentStatus}
                options={[
                  { label: "Confirmed", value: 63 },
                  { label: "Backout", value: 65 },
                  { label: "Not Joined", value: 66 },
                  { label: "BGV Failed", value: 67 },
                  { label: "Start", value: 71 },
                ]}
                onChange={(option) => handleStatusChange(option, row)}
                showSearch
              />
            </div>
          </div>
        );
      },
    },
    {
      key: "",
      label: "Action",

      render: (row) => {
        const lastStatus = row?.statusHistory?.[row?.statusHistory?.length - 1]?.status;
        const isStartStatus = lastStatus === 71;
        const isDisabled = row.isPushedToWorkforce || !isStartStatus;
        
        let description = "Push data to Workforce";
        if (row.isPushedToWorkforce) description = "Already Pushed to Workforce";
        else if (!isStartStatus) description = "Candidate must be in Start status";

        return (
          <div className="flex justify-center w-full pl-2 pr-4">
            <SmartTooltip noicon description={description}>
              <Link
                to={isDisabled ? "#" : `/ats/bdm/push-data-to-workforce`}
                state={{ submissionId: row.uiid }}
                className={`text-sm! flex items-center justify-center ${
                  isDisabled
                    ? "pointer-events-none opacity-50 cursor-not-allowed text-gray-400" 
                    : ""
                }`}
              >
                <span className="material-symbols-outlined text-base!">
                  publish
                </span>
              </Link>
            </SmartTooltip>
          </div>
        );
      },
    },
  ];
  const handleStatusChange = async (option, row) => {
    try {
      setStatusLoading(true);
      const newStatus = option;

      // build payload to push into statusHistory
      const payload = [
        {
          type: "PUSH",
          value: {
            statusHistory: {
              addedBy: user?.data?.uiid,
              addedOn: new Date().toISOString(),
              status: newStatus,
            },
          },
        },
      ];

      const res = await updateSubmissionStatus({
        coll: "Submission",
        uiid: row?.uiid,
        payload,
      });

      if (res?.data) {
        showToast("Status updated successfully", "success");
        const payload = {
          coll: "Submission",
          lim: 10,
          pg: 1,
          ref: "JobPosting Candidate",
          fil: {
            "statusHistory.status": {
              type: "ARRAY_LAST_TWO_FIELDS_EQ",
              value: [63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76],
            },
          },
          extret: "uiid firstName",
          ret: "uiid addedBy jobPostId updatedAt statusHistory addedOn isPushedToWorkforce",
          incl: [
            "uiid jobInfo.jobCode jobInfo.endClient companyId",
            "uiid firstName lastName jobTitle",
          ],
          sort: { addedOn: -1 },
        };

        dispatch(fetchConfirmedOrStartStart(payload));
      } else {
        showToast("Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "error");
    } finally {
      setStatusLoading(false);
    }
  };

  // const rows = Array.from({ length: 10 }, (_, i) => ({
  //   fullName: "Astha Vaish",
  //   startDate: "March 5, 2025",
  //   interviewEndDate: "April 5, 2025",
  //   accountName: "Astha",
  //   submittedBy: "Chandan",
  //   submittedOn: "March 15, 2025",
  //   status: "",
  // }));
  const rows =
    data?.map((item) => ({
      fullName: `${formatWords2(item?.candidateId?.firstName || "—")} ${formatWords2(item?.candidateId?.lastName || "")}`,
      accountName: formatWords2(item?.jobPostId?.jobInfo?.endClient || item?.jobPostId?.companyId?.name || item?.jobPostId?.jobId?.companyId?.name || "—"),
      jobtitle: formatWords2(item?.candidateId?.jobTitle || "—"),
      jobid: item?.jobPostId?.jobInfo?.jobCode || "—",
      createdby: formatWords2(item?.addedBy?.firstName || "—"),
      createdon: dateFormator(convertFromUTC(item?.addedOn), "full"),
      statusHistory: item?.statusHistory || [],
      uiid: item?.uiid || null,
      candidateUiid: item?.candidateId?.uiid,
      candidateFirstName: item?.candidateId?.firstName || "",
      candidateLastName: item?.candidateId?.lastName || "",
      candidateEmail: item?.candidateId?.email?.primary?.email || "",
      candidatePhone: (item?.candidateId?.mobile?.primary?.code || "") + (item?.candidateId?.mobile?.primary?.number || ""),
      candidateGender: item?.candidateId?.gender || undefined,
      candidateDob: exactUTCDate(item?.candidateId?.dob),
      candidateLocation: item?.candidateId?.location || {},
      candidatePayRate: item?.candidateId?.salaryInfo?.payRate?.amount || "",
      // Job / Placement data from jobPosting
      jobStartDate: exactUTCDate(item?.jobPostId?.jobInfo?.jobDates?.start),
      jobEndDate: exactUTCDate(item?.jobPostId?.jobInfo?.jobDates?.end),
      jobBillRate: item?.jobPostId?.jobInfo?.payments?.billRate?.amount || "",
      jobPayRate: item?.jobPostId?.jobInfo?.payments?.payRate?.amount?.min || item?.jobPostId?.jobInfo?.payments?.payRate?.amount || "",
      offeredSalary: item?.candidateId?.salaryInfo?.offeredSalary?.amount || "",
      targetPercentage: item?.jobPostId?.jobInfo?.payments?.commission?.amount || "",
      warrantyPeriod: item?.jobPostId?.jobInfo?.warranty?.period || "",
      notes: item?.candidateId?.notes || [],
      // Team member ATS UUIDs for PTW incentive enrichment
      teamNotifyTo: item?.jobPostId?.notifyTo || [],   // RE (Recruiting Executive)
      teamAssignedTo: item?.jobPostId?.assignedTo || null, // DM (Delivery Manager)
      teamAddedBy: item?.addedBy?.uiid || null,        // RA (Recruiting Account) — submission creator
      isPushedToWorkforce: item?.isPushedToWorkforce || false,
    })) || [];
  const mappedRows = mapTableRows(rows, columns);
  useEffect(() => {
    const payload = {
      coll: "Submission",
      lim: limit,
      pg: page,
      ref: "JobPosting Candidate",
      fil: {
        "statusHistory.status": {
          type: "ARRAY_LAST_TWO_FIELDS_EQ",
          value: [63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76],
        },
      },
      extret: "uiid firstName",
      ret: "uiid addedBy jobPostId updatedAt statusHistory addedOn isPushedToWorkforce",
      incl: [
        "uiid jobInfo.jobCode jobInfo.endClient jobInfo.jobDates jobInfo.payments companyId notifyTo assignedTo",
        "uiid firstName lastName jobTitle email mobile gender dob location salaryInfo notes",
      ],
      sort: { addedOn: -1 },
    };
    dispatch(
      totalCountStart({
        collection: "submissions",
        coll: "Submission",
        tname: "confirmedSubCount",
        filters: {
          "statusHistory.status": {
            type: "ARRAY_LAST_TWO_FIELDS_EQ",
            value: [63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76],
          },
        },
        app: "ats",
      }),
    );

    dispatch(fetchConfirmedOrStartStart(payload));
  }, [dispatch, limit, page]);



  return (
    <div className="flex flex-col mt-5 mb-0 flex-1 overflow-hidden">
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="flex-1 flex overflow-hidden">
          <TableAdv
            showCheckbox
            rows={mappedRows}
            columns={columns}
            serverPagination={true}
            totalCount={totalCount}
            onSelectionChange={setSelectedRows}
            defaultSelectedRows={selectedRows}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            tableId={"BDM_confirmedstarts"}
            onLimitChange={handleLimitChange}
            tdClassName="!py-2"
            toolbarRight={{
             // search: true,
              filter: true,
              download: false,
            }}
          />
        </div>
      </div>
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        onClose={() => setDetailsDrawer(false)}
        applicantId={selectedApplicantId}
      />
      <Backdrop isOpen={loading || statusLoading} zIndex={51}>
        <LogoLoader />
      </Backdrop>
      <AddNoteModal
        isOpen={noteModal}
        onClose={() => setNotesModal(false)}
        data={filterData}
      />
    </div>
  );
};

export default Confirmed;
